export {
  default as shvimplyLogo,
  ReactComponent as ShvimplyLogo,
} from '@assets/shvimply-logo.svg'
